import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class UnlinkAuthorizeNetCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IUnlinkAuthorizeNetParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.DELETE;
  override _commandUrl = 'vendor/authorize/{userId}/{appId}';
  public override setParameters(parameters: IUnlinkAuthorizeNetParameters) {
    this._commandUrl = this._commandUrl
      .replace('{userId}', parameters.userId.toString())
      .replace('{appId}', parameters.appId.toString());
  }
}

export interface IUnlinkAuthorizeNetParameters extends ICommandParameters {
  userId: number;
  appId: number;
}
